// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"7281":"146cc26d843cdd2b","7500":"027179019e5307be"}[chunkId] + ".css";
};